module.exports = __webpack_public_path__ + "img/2.6eab3290.jpg";